// GENERATED BY tools/gen_web_theme.py - DO NOT EDIT.
//
// The ONE owner is theme/RevivalTheme.cs. Editing this file makes
// a second owner of the brand palette, and the router picks the loser. Change the C# and
// re-run the generator; `--check` fails the build if this is stale.

export const Theme = {
  Accent: "#7FE3B4",
  Action: "#E08A3C",
  AccentInk: "#14110F",
  Display: "#E8E2D4",
  Muted: "#9FB2AE",
  Panel: "#17171FEB",
  Scrim: "#08080D8C",
  Ink: "#0B1016",
  RealmNegafook: "#6FA8D6",
  RealmVerdant: "#6FBF7F",
  RealmScorched: "#E2622F",
  RealmSpirit: "#A99BD6",
  RealmIron: "#9A8B7A",
  RealmNeutral: "#9FB2AE",
  LegacyAccent: "#F45D0D",
  LegacyButton: "#AD3926",
  PrimaryFill: "#2A1C14",
  SecondaryFill: "#141C22",
  ButtonFill: "#11181E",
} as const;

export const Copy = {
  Tagline: "PLAY FOR KEEPS",
  EnterLabel: "STEP PAST THE LAST FENCE",
} as const;

/** Every palette entry as a CSS custom property on :root. */
export function installCssVars(el: HTMLElement = document.documentElement): void {
  for (const [k, v] of Object.entries(Theme)) {
    el.style.setProperty(`--${k.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, v);
  }
}
